import { Footer } from "./Footer";
import type { FooterProps, FooterColumn } from "./types";

export { Footer, type FooterProps, type FooterColumn };
